import { ChartInterval } from 'app/agriculture/hooks/useAggregateChartData/useAggregateChartData';
import { createContext } from 'react';

interface ChartContextType {
    intervalUnit: ChartInterval;
    dateFormat?: string;
}

export const ChartContext = createContext<ChartContextType>({} as ChartContextType);

export const ChartContextProvider = ({
    children,
    intervalUnit,
    dateFormat,
}: {
    children: React.ReactNode;
} & ChartContextType) => {
    return (
        <ChartContext.Provider
            value={{
                intervalUnit,
                dateFormat,
            }}
        >
            {children}
        </ChartContext.Provider>
    );
};
